import { render, staticRenderFns } from "./ShowHDRLcdCalibrationColorBoxChart.vue?vue&type=template&id=dd7f16ba"
import script from "./ShowHDRLcdCalibrationColorBoxChart.vue?vue&type=script&lang=js"
export * from "./ShowHDRLcdCalibrationColorBoxChart.vue?vue&type=script&lang=js"
import style0 from "./ShowHDRLcdCalibrationColorBoxChart.vue?vue&type=style&index=0&id=dd7f16ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports